import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = process.env.REACT_APP_BACKEND_URL;

const authHeaders = () => {
  const token = localStorage.getItem('yppsdp_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Resolve upload URL to full backend URL
export const resolveUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/uploads/')) return `${BACKEND}${url}`;
  return url;
};

export const api = {
  // Public
  listNews: async () => (await axios.get(`${API}/news`)).data,
  getNews: async (slug) => (await axios.get(`${API}/news/${slug}`)).data,
  listLeadership: async () => (await axios.get(`${API}/leadership`)).data,
  search: async (q) => (await axios.get(`${API}/search`, { params: { q } })).data,

  // Auth
  login: async (username, password) => (await axios.post(`${API}/auth/login`, { username, password })).data,
  me: async () => (await axios.get(`${API}/auth/me`, { headers: authHeaders() })).data,

  // Admin CRUD
  createNews: async (data) => (await axios.post(`${API}/admin/news`, data, { headers: authHeaders() })).data,
  updateNews: async (id, data) => (await axios.put(`${API}/admin/news/${id}`, data, { headers: authHeaders() })).data,
  deleteNews: async (id) => (await axios.delete(`${API}/admin/news/${id}`, { headers: authHeaders() })).data,
  createLeadership: async (data) => (await axios.post(`${API}/admin/leadership`, data, { headers: authHeaders() })).data,
  updateLeadership: async (id, data) => (await axios.put(`${API}/admin/leadership/${id}`, data, { headers: authHeaders() })).data,
  deleteLeadership: async (id) => (await axios.delete(`${API}/admin/leadership/${id}`, { headers: authHeaders() })).data,
  seedData: async (force = false) => (await axios.post(`${API}/admin/seed`, {}, { headers: authHeaders(), params: force ? { force: true } : {} })).data,

  // Upload
  uploadImage: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const r = await axios.post(`${API}/admin/upload`, form, { headers: { ...authHeaders(), 'Content-Type': 'multipart/form-data' } });
    return { ...r.data, fullUrl: resolveUrl(r.data.url) };
  },

  // Users
  listUsers: async () => (await axios.get(`${API}/admin/users`, { headers: authHeaders() })).data,
  createUser: async (data) => (await axios.post(`${API}/admin/users`, data, { headers: authHeaders() })).data,
  deleteUser: async (username) => (await axios.delete(`${API}/admin/users/${username}`, { headers: authHeaders() })).data,
};
